module.exports = __webpack_public_path__ + "static/media/iconLogoLogin.9f343985.svg";